import { Component, Input, type OnInit } from '@angular/core'
import { CptSharedDataService, PwaService } from '@inside-hub-app/customer-portal-shared'
import { type B2CConfig } from '@inside-hub-app/customer-portal-config'
import { EfRemoteConfigurationService } from '@inside-hub-app/ef-remote-config'

@Component({
  selector: 'customer-portal-app-revolution-main-view',
  templateUrl: './revolution-main-view.component.html'
})
export class RevolutionMainViewComponent implements OnInit {
  @Input() view = ''
  public backgroundAsset = 'assets/images/EF_Revolution_Hero_Landingpage.jpg'
  public backgroundAssetMobile = 'assets/images/login-background.jpg'
  countryCode: string
  hasNewGDPR
  backgroundUrl: string
  backgroundUrlMobile: string
  isMobile
  constructor (
    private readonly sharedData: CptSharedDataService,
    private readonly remoteConfigService: EfRemoteConfigurationService<B2CConfig>,
    private readonly pwaService: PwaService
  ) {
    this.isMobile = this.pwaService.checkMobile()
    this.countryCode = this.remoteConfigService.get('country.code')
    this.hasNewGDPR = this.remoteConfigService.get('hasNewGDPR')
  }

  ngOnInit (): void {
    this.backgroundUrl = `url('${this.sharedData.getResourcesPath()}/${
      this.backgroundAsset
    }')`
    this.backgroundUrlMobile = `url('${this.sharedData.getResourcesPath()}/${
      this.backgroundAssetMobile
    }')`
  }

  isMobileLogin (): boolean {
    return (this.isMobile === true && this.view === 'login' && this.countryCode === 'de')
  }

  getBackground (): string {
    return this.isMobileLogin() ? this.backgroundUrlMobile : ''
  }
}
